import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonApp, IonRouterOutlet } from '@ionic/vue';
import { NativeAudio } from '@capacitor-community/native-audio';
import { Capacitor } from '@capacitor/core';
import PlayerMenu from '@/components/player-menu.vue';
import { onMounted } from 'vue';
import '@lbgm/phone-number-input/style';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const loadAudio = (path: string, id: string, num: number) => {
  const assetPath = Capacitor.getPlatform() === 'ios' ? `sounds/${path}` : path;

  return NativeAudio.preload({
    assetId: id,
    assetPath: assetPath,
    audioChannelNum: num,
    isUrl: false,
  });
};

const preloadAudios = async () => {
  await loadAudio('background-sound.mp3', 'background_music', 1);
  await loadAudio('lclick-13694.mp3', 'click', 2);
  await loadAudio('success-1-6297.mp3', 'success', 3);
  await loadAudio('error-126627.mp3', 'invalid', 4);
  await loadAudio('tada-fanfare-a-6313.mp3', 'congrat', 5);
};

onMounted(() => {
  requestAnimationFrame(() => {
    preloadAudios();
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createVNode(PlayerMenu),
      _createVNode(_unref(IonRouterOutlet))
    ]),
    _: 1
  }))
}
}

})